import React from "react";
import AgentForceChatBotContainer from ".";

function AFChatOption({ config: { open, displayTimes, percentage } }) {
  const getIfEnabled = () => Math.random() < percentage / 100;

  const getChatDOM = () => {
    if (!getIfEnabled()) {
      return null;
    }
    return <AgentForceChatBotContainer open={open} displayTimes={displayTimes} />;
  };

  return getChatDOM();
}

export default AFChatOption;
